import { render, staticRenderFns } from "./LawCollectionEntityPage.vue?vue&type=template&id=2206afdc&scoped=true"
import script from "./LawCollectionEntityPage.vue?vue&type=script&lang=js"
export * from "./LawCollectionEntityPage.vue?vue&type=script&lang=js"
import style0 from "./LawCollectionEntityPage.vue?vue&type=style&index=0&id=2206afdc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2206afdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2206afdc')) {
      api.createRecord('2206afdc', component.options)
    } else {
      api.reload('2206afdc', component.options)
    }
    module.hot.accept("./LawCollectionEntityPage.vue?vue&type=template&id=2206afdc&scoped=true", function () {
      api.rerender('2206afdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LawCollectionEntityPage.vue"
export default component.exports